import { tokens } from '@/design';
import type { ProfileAnomaly } from './fixtures';

export interface ProfileAnomalyDetailProps {
  readonly anomalies: ReadonlyArray<ProfileAnomaly>;
  readonly onSelectAnomaly: (id: string) => void;
}

export function ProfileAnomalyDetail({
  anomalies,
  onSelectAnomaly,
}: ProfileAnomalyDetailProps) {
  if (anomalies.length === 0) return null;

  return (
    <div
      data-testid="profile-anomaly-detail"
      role="list"
      aria-label="Anomaly markers"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.space[1],
        padding: tokens.space[2],
      }}
    >
      {anomalies.map((anomaly) => (
        <button
          key={anomaly.id}
          type="button"
          role="listitem"
          aria-label={`Anomaly: ${anomaly.reason}; Confidence: ${anomaly.confidence}; Out of tolerance by ${anomaly.delta} ${anomaly.unit}`}
          onClick={() => onSelectAnomaly(anomaly.id)}
          data-testid={`anomaly-chip-${anomaly.id}`}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: tokens.space[2],
            padding: `${tokens.space[1]}px ${tokens.space[2]}px`,
            background: tokens.color.surface[2],
            border: `${tokens.border.width.thin}px solid ${anomaly.confidence === 'high' ? tokens.color.semantic.danger : tokens.color.semantic.warning}`,
            borderRadius: tokens.radius.chip,
            cursor: 'pointer',
            textAlign: 'left',
            minHeight: tokens.density.touchMin,
            color: tokens.color.ink.primary,
          }}
        >
          <span
            className="material-symbols-outlined"
            aria-hidden="true"
            style={{
              color:
                anomaly.confidence === 'high'
                  ? tokens.color.semantic.danger
                  : tokens.color.semantic.warning,
              fontSize: 18,
            }}
          >
            {anomaly.confidence === 'high' ? 'warning' : 'report'}
          </span>
          <span style={{ fontSize: tokens.font.size.xs, flex: 1 }}>
            {anomaly.reason}
          </span>
          <span
            style={{
              fontFamily: tokens.font.family.mono,
              fontSize: tokens.font.size.xs,
              color: tokens.color.ink.muted,
            }}
          >
            Δ{anomaly.delta} {anomaly.unit}
          </span>
        </button>
      ))}
    </div>
  );
}
